import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 10, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Team() {
  const [managers, setManagers] = useState([]);
  const [agents, setAgents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ email: '', name: '', password: '', agent_ids: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const [m, a] = await Promise.all([api.get('/team'), api.get('/agents')]);
      setManagers(m.data); setAgents(a.data);
    } catch (e) {
      if (e.response?.status === 403) {
        setError('Только владелец может управлять командой');
      }
    }
  };
  useEffect(() => { load(); }, []);

  const toggleAgent = (id) => {
    setForm(f => ({ ...f, agent_ids: f.agent_ids.includes(id) ? f.agent_ids.filter(x => x !== id) : [...f.agent_ids, id] }));
  };

  const save = async () => {
    setError('');
    if (!form.email) { setError('Введите email'); return; }
    if (!editId && !form.password) { setError('Введите пароль'); return; }
    setLoading(true);
    try {
      if (editId) {
        await api.put(`/team/${editId}`, { name: form.name, password: form.password || undefined, agent_ids: form.agent_ids });
      } else {
        await api.post('/team', form);
      }
      setShowForm(false); setEditId(null);
      setForm({ email: '', name: '', password: '', agent_ids: [] });
      await load();
    } catch (e) { setError(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const del = async (id, name) => {
    if (!window.confirm(`Удалить менеджера «${name}»?`)) return;
    await api.delete(`/team/${id}`);
    await load();
  };

  const edit = (m) => {
    setEditId(m.id);
    setForm({ email: m.email, name: m.name || '', password: '', agent_ids: m.agent_ids || [] });
    setShowForm(true);
  };

  const toggleActive = async (m) => {
    await api.put(`/team/${m.id}`, { is_active: !m.is_active });
    await load();
  };

  if (error && managers.length === 0) return (
    <div style={{ padding: 32 }}>
      <div style={{ color: '#c0392b', fontSize: 14 }}>{error}</div>
    </div>
  );

  if (showForm) return (
    <div style={{ padding: 32, maxWidth: 520 }}>
      <button onClick={() => { setShowForm(false); setEditId(null); setError(''); }} style={btnGhost}>← Назад</button>
      <h2 style={{ fontSize: 18, fontWeight: 600, margin: '16px 0 20px' }}>
        {editId ? 'Редактировать менеджера' : 'Новый менеджер'}
      </h2>

      <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Имя</label>
      <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} placeholder="Имя менеджера" />

      <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>Email (логин)</label>
      <input value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inp} placeholder="manager@example.com" disabled={!!editId} />

      <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>
        Пароль {editId && <span style={{ color: '#aaa', fontWeight: 400 }}>(оставьте пустым чтобы не менять)</span>}
      </label>
      <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={inp} placeholder={editId ? 'Новый пароль...' : 'Пароль'} />

      <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 8 }}>Доступные агенты</label>
      <div style={{ fontSize: 12, color: '#888', marginBottom: 10 }}>Менеджер будет видеть диалоги только этих агентов</div>
      <div style={{ display: 'grid', gap: 6, marginBottom: 16 }}>
        {agents.map(a => (
          <label key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', border: `1px solid ${form.agent_ids.includes(a.id) ? '#534AB7' : '#e8e8e6'}`, borderRadius: 8, cursor: 'pointer', background: form.agent_ids.includes(a.id) ? '#f0effe' : '#fff', fontSize: 13 }}>
            <input type="checkbox" checked={form.agent_ids.includes(a.id)} onChange={() => toggleAgent(a.id)} />
            <span>{a.name}</span>
          </label>
        ))}
        {agents.length === 0 && <div style={{ color: '#aaa', fontSize: 13 }}>Агентов нет — создайте сначала</div>}
      </div>

      {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{error}</div>}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={save} disabled={loading} style={btnPrimary}>{loading ? 'Сохраняем...' : 'Сохранить'}</button>
        <button onClick={() => { setShowForm(false); setEditId(null); }} style={btnGhost}>Отмена</button>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Команда</h1>
        <button onClick={() => { setShowForm(true); setEditId(null); setForm({ email: '', name: '', password: '', agent_ids: [] }); }} style={btnPrimary}>
          + Добавить менеджера
        </button>
      </div>

      {managers.length === 0 && (
        <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>
          Менеджеров нет. Добавьте первого.
        </div>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {managers.map(m => {
          const managerAgents = agents.filter(a => m.agent_ids?.includes(a.id));
          return (
            <div key={m.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#f0effe', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                👤
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{m.name || m.email}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{m.email}</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                  {managerAgents.length === 0
                    ? <span style={{ fontSize: 11, color: '#aaa' }}>Агенты не назначены</span>
                    : managerAgents.map(a => (
                      <span key={a.id} style={{ fontSize: 11, background: '#f0effe', color: '#534AB7', padding: '2px 8px', borderRadius: 10 }}>
                        🤖 {a.name}
                      </span>
                    ))}
                </div>
              </div>
              <span style={{ fontSize: 12, color: m.is_active ? '#27ae60' : '#aaa' }}>
                {m.is_active ? '● активен' : '○ отключён'}
              </span>
              <button onClick={() => toggleActive(m)} style={btnGhost}>
                {m.is_active ? 'Отключить' : 'Включить'}
              </button>
              <button onClick={() => edit(m)} style={btnGhost}>✏️ Редактировать</button>
              <button onClick={() => del(m.id, m.name || m.email)} style={btnDanger}>🗑</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
